import React, { useEffect, useRef, useState } from 'react';
import {
   Box,
   Button,
   Grid,
   IconButton,
   Paper,
   Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import { useForm } from 'react-hook-form';
import { endOfDay, format } from 'date-fns';
import { enUS, th } from 'date-fns/locale';
import 'react-nice-dates/build/style.css';
import { DatePicker, useDateInput } from 'react-nice-dates';
import { TitleLabel } from '../../Element/LabelInputForm';
import Axios from 'axios';
import ErrorPopup from '../../Error/ErrorPopup';
import { useSnackbar } from 'notistack';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import dayjs from 'dayjs';
import { AlertLabel, Input } from '../../../assets/styled/Element';
import { MySelect } from '../../Select/Select';
import LoadingPopup from '../../Loading/LoadingPopup';
import { checkCodeDivision } from '../../../configs/helpers/utility';

const useStyles = makeStyles((theme) => ({
   backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
   },
   paper: {
      padding: theme.spacing(2, 4, 3),
      width: '40%',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
      height: '550px',
   },
   role: {
      color: '#5858FA',
   },
   title: {
      color: '#6E6E6E',
   },
   large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   content: {
      margin: theme.spacing(0, 1),
      width: '100%',
   },
   headerL: {
      margin: theme.spacing(1),
   },
   listStyle: {
      height: '65px',
   },
   flexGrid: {
      display: 'flex',
      alignItems: 'center',
   },
   qrPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
   },
   detailRight: {
      height: '280px',
      overflow: 'auto',
   },
}));

const walletType = [
   { value: null, label: 'เลือกทั้งหมด' },
   { value: 'g', label: 'ประเภท : G' },
   { value: 's', label: 'ประเภท : S' },
   { value: 'b', label: 'ประเภท : B' },
];
const CreateReportCollectPoint = (props) => {
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const [rewardRes, setRewardRes] = useState([]);
   const [optionsReward, setOptionsReward] = useState([]);
   const [rewardLoading, setRewardLoading] = useState(false);
   const closeRef = useRef();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const { handleSubmit, register, errors, watch, setValue, getValues } =
      useForm({
         defaultValues: {
            // currencyPoint: [],
         },
      });
   const selectStartDate = watch('startDate');
   const selectEndDate = watch('endDate');
   const selectedType = watch('currencyPoint');
   const selectDepartment = watch('department');
   const selectDistrict = watch('district');
   const selectBranch = watch('branch');
   useEffect(() => {
      register({ name: 'startDate' });
      register({ name: 'endDate' });
      register({ name: 'currencyPoint' }, { required: true });
      register({ name: 'department' });
      register({ name: 'district' });
      register({ name: 'branch' });
   }, [register]);
   useEffect(() => {
      getDepartmentList();
      getDistrictList();
      getBranchList();
   }, []);

   const setsSelectedType = (e) => setValue('currencyPoint', e);
   const handleStartDateChange = (e) => setValue('startDate', e);
   const handleEndDateChange = (type) => (e) => {
      if (type === 'auto') setValue('endDate', endOfDay(e));
      else setValue('endDate', e);
   };
   const timeStartInputProps = useDateInput({
      date: getValues('startDate'),
      format: 'HH:mm',
      locale: th,
      onDateChange: handleStartDateChange,
   });
   const timeEndInputProps = useDateInput({
      date: getValues('endDate'),
      format: 'HH:mm',
      locale: th,
      onDateChange: handleEndDateChange('manual'),
   });
   const onSubmit = (e) => {
      sessionStorage.setItem('value', JSON.stringify(e));
      if (sessionStorage['value']) {
         const values = JSON.parse(sessionStorage.getItem('value'));
         postData(values);
      }
   };

   const postData = (values) => {
      setIsLoading(true);
      const result = {
         startDate: values.startDate
            ? format(new Date(values.startDate), 'dd/MM/yyyy HH:mm:ss')
            : null,
         endDate: values.endDate
            ? format(new Date(values.endDate), 'dd/MM/yyyy HH:mm:ss')
            : null,
         currencyPoint: values.currencyPoint.value,
         divisionCode: checkCodeDivision(values),
      };
      Axios.post('/GSB/dashboard/report/GetEmployeePointReport', result)
         .then((resp) => {
            enqueueSnackbar('สร้างรายการสำเร็จ!!', {
               variant: 'success',
            });
            props.onSuccess();
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            sessionStorage.removeItem('value');
            setIsLoading(false);
         });
   };
   const [sCodeDefault, setSCodeDefault] = useState(['10000000']);
   const [departmentRes, setDepartmentRes] = useState([]);
   const [optionsDepartment, setOptionsDepartment] = useState([]);
   const [departmentLoading, setDepartmentLoading] = useState(false);
   const getDepartmentList = () => {
      setDepartmentLoading(true);
      const payLoad = {
         divisionShortCode: sCodeDefault,
         level: 4,
      };
      Axios.post('/GSB/app/dashboard/GetDropdownDetail', payLoad)
         .then((resp) => {
            setDepartmentRes(resp.data);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            }
         });
   };
   useEffect(() => {
      setDepartment();
   }, [departmentRes]);
   const setDepartment = () => {
      if (departmentRes.length > 0) {
         const formatted = departmentRes.map((value) => {
            return Object.assign({}, { value, label: value.fullName });
         });
         setOptionsDepartment(formatted);
      } else {
         setOptionsDepartment([]);
      }
      setDepartmentLoading(false);
   };
   const handleChangeDepartment = (e) => {
      if (!e) {
         setValue('department', false);
         setValue('district', false);
         setValue('branch', false);
      } else {
         setValue('department', e);
         if (e.length === 0) {
            setValue('department', false);
            setValue('district', false);
            setValue('branch', false);
         }
      }
      getDistrictList();
   };

   const [districtRes, setDistrictRes] = useState([]);
   const [optionsDistrict, setOptionsDistrict] = useState([]);
   const [districtLoading, setDistrictLoading] = useState(false);
   const getDistrictList = () => {
      setDistrictLoading(true);
      const value = getValues('department');
      let arr;
      if (value && value.length > 0) {
         arr = value.map((obj) => obj.value.shortCode);
      } else {
         arr = ['10000000'];
      }
      const payLoad = {
         divisionShortCode: arr,
         level: 5,
      };
      Axios.post('/GSB/app/dashboard/GetDropdownDetail', payLoad)
         .then((resp) => {
            setDistrictRes(resp.data);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            }
         });
   };
   useEffect(() => {
      setDistrict();
   }, [districtRes]);
   const setDistrict = () => {
      if (districtRes.length > 0) {
         const formatted = districtRes.map((value) => {
            return Object.assign({}, { value, label: value.fullName });
         });
         setOptionsDistrict(formatted);
      } else {
         setOptionsDistrict([]);
      }
      setDistrictLoading(false);
   };
   const handleChangeDistrict = (e) => {
      if (!e) {
         setValue('district', false);
         setValue('branch', false);
      } else {
         setValue('district', e);
         if (e.length === 0) {
            setValue('district', false);
            setValue('branch', false);
         }
      }
      getBranchList();
   };
   const [branchRes, setBranchRes] = useState([]);
   const [optionsBranch, setOptionsBranch] = useState([]);
   const [branchLoading, setBranchLoading] = useState(false);
   const getBranchList = () => {
      setBranchLoading(true);
      const value = getValues('district');
      let arr;
      if (value && value.length > 0) {
         arr = value.map((obj) => obj.value.shortCode);
      } else {
         arr = ['10000000'];
      }
      const payLoad = {
         divisionShortCode: arr,
         level: 6,
      };
      Axios.post('/GSB/app/dashboard/GetDropdownDetail', payLoad)
         .then((resp) => {
            setBranchRes(resp.data);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            }
         });
   };
   useEffect(() => {
      setBranch();
   }, [branchRes]);
   const setBranch = () => {
      if (branchRes.length > 0) {
         const formatted = branchRes.map((value) => {
            return Object.assign({}, { value, label: value.fullName });
         });
         setOptionsBranch(formatted);
      } else {
         setOptionsBranch([]);
      }
      setBranchLoading(false);
   };
   const handleChangeBranch = (e) => {
      setValue('branch', e);
   };

   if (isLoading) return <LoadingPopup />;
   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );
   return (
      <Paper className={classes.paper}>
         <div className={classes.header}>
            <Typography variant={'h4'}>ตัวกรองรายงานการสะสมคะแนน</Typography>
            <IconButton
               className={classes.headerL}
               size={'small'}
               onClick={props.onClickClose}
               ref={closeRef}
            >
               <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
         </div>
         <form onSubmit={handleSubmit(onSubmit)}>
            <Box
               display={'flex'}
               alignItems={'flex-start'}
               flexDirection={'column'}
               fontSize={20}
            >
               <Box display={'flex'} width={'100%'}>
                  <Grid container spacing={2}>
                     <Grid item xs={3}>
                        <TitleLabel Fs={'14px'}>
                           ประเภทคะแนน&nbsp;:&nbsp;
                           {errors.currencyPoint && (
                              <AlertLabel>กรุณาเลือกประเภทคะแนน</AlertLabel>
                           )}
                        </TitleLabel>
                        {/*<SelectMultiAll*/}
                        {/*  options={walletType}*/}
                        {/*  isLoading={rewardLoading}*/}
                        {/*  value={selectedType}*/}
                        {/*  onChange={setsSelectedType}*/}
                        {/*  placeholder={'เลือกประเภทคะแนน'}*/}
                        {/*  isDisabled={rewardLoading}*/}
                        {/*/>*/}
                        <MySelect
                           options={walletType}
                           value={selectedType}
                           onChange={setsSelectedType}
                           placeholder={'เลือกประเภทคะแนน'}
                           closeMenuOnSelect
                        />
                     </Grid>
                     <Grid item xs={9}>
                        &nbsp;&nbsp;
                     </Grid>
                     <Grid item xs={12}>
                        <TitleLabel>ฝ่าย/ภาค</TitleLabel>
                        <MySelect
                           placeholder={'เลือกฝ่าย/ภาค'}
                           options={optionsDepartment}
                           isLoading={departmentLoading}
                           isDisabled={departmentLoading}
                           value={selectDepartment}
                           onChange={handleChangeDepartment}
                           isMulti
                        />
                     </Grid>
                     <Grid item xs={12}>
                        <TitleLabel>ส่วน/เขต</TitleLabel>
                        <MySelect
                           placeholder={'เลือกฝ่าย/ภาค'}
                           options={optionsDistrict}
                           isLoading={districtLoading}
                           isDisabled={!getValues('department')}
                           value={selectDistrict}
                           onChange={handleChangeDistrict}
                           isMulti
                        />
                     </Grid>
                     <Grid item xs={12}>
                        <TitleLabel>หน่วยงาน/สาขา</TitleLabel>
                        <MySelect
                           placeholder={'หน่วยงาน/สาขา'}
                           options={optionsBranch}
                           isLoading={branchLoading}
                           isDisabled={!getValues('district')}
                           value={selectBranch}
                           onChange={handleChangeBranch}
                           isMulti
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           เลือกระยะวันที่และเวลาของรายงาน
                           {(errors.startDate || errors.endDate) && (
                              <AlertLabel>
                                 กรุณาเลือกระยะวันที่และเวลาของรายงาน
                              </AlertLabel>
                           )}
                        </TitleLabel>
                        <Box style={{ position: 'relative' }}>
                           <DatePicker
                              date={selectStartDate}
                              onDateChange={handleStartDateChange}
                              locale={enUS}
                           >
                              {({ inputProps, focused }) => (
                                 <Box width={'100%'}>
                                    <Input
                                       className={
                                          'input' + (focused ? ' -focused' : '')
                                       }
                                       {...inputProps}
                                       value={`${
                                          inputProps.value &&
                                          dayjs(
                                             new Date(inputProps.value),
                                          ).format('DD/MM/BBBB')
                                       }`}
                                       width={'52%'}
                                       margin={'0px 3% 0px 0px'}
                                       placeholder={'เลือกวันที่'}
                                       readOnly
                                    />
                                    <Input
                                       className={'input'}
                                       {...timeStartInputProps}
                                       width={'45%'}
                                       type={'time'}
                                    />
                                 </Box>
                              )}
                           </DatePicker>
                        </Box>
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>&nbsp;</TitleLabel>
                        <Box style={{ position: 'relative' }}>
                           <DatePicker
                              date={selectEndDate}
                              onDateChange={handleEndDateChange('auto')}
                              locale={enUS}
                           >
                              {({ inputProps, focused }) => (
                                 <Box width={'100%'}>
                                    <Input
                                       className={
                                          'input' + (focused ? ' -focused' : '')
                                       }
                                       {...inputProps}
                                       value={`${
                                          inputProps.value &&
                                          dayjs(
                                             new Date(inputProps.value),
                                          ).format('DD/MM/BBBB')
                                       }`}
                                       width={'52%'}
                                       margin={'0px 3% 0px 0px'}
                                       placeholder={'เลือกวันที่'}
                                       readOnly
                                    />
                                    <Input
                                       className={'input'}
                                       {...timeEndInputProps}
                                       width={'45%'}
                                       type={'time'}
                                    />
                                 </Box>
                              )}
                           </DatePicker>
                        </Box>
                     </Grid>
                  </Grid>
               </Box>
               <Box mt={3}>
                  <Box>
                     <Button
                        variant={'contained'}
                        color={'primary'}
                        type={'submit'}
                     >
                        สร้างรายการ
                     </Button>
                     <Button variant={'contained'} onClick={props.onClickClose}>
                        ยกเลิก
                     </Button>
                  </Box>
               </Box>
            </Box>
         </form>
      </Paper>
   );
};

export default CreateReportCollectPoint;
